module.exports = __webpack_public_path__ + "img/result7.77fca989.png";